import { apiSlice } from "../../app/api/apiSlice";

export const fetchEnhancedConditionsEfolderDocumentsDownloadUrlsListApiSlice =
	apiSlice.injectEndpoints({
		endpoints: (builder) => ({
			enhancedConditionsEfolderDocumentsDownloadUrlsList: builder.mutation({
				query: (credentials) => ({
					url: `api/v1/loan/get_enhanced_conditions_efolder_attachments_downloadUrl/${credentials.loanGuid}`,
					method: "POST",
					body: {
						attachmentIds: credentials.attachmentIds
					}
				}),
			}),
		}),
	});

export const { useEnhancedConditionsEfolderDocumentsDownloadUrlsListMutation } =
	fetchEnhancedConditionsEfolderDocumentsDownloadUrlsListApiSlice;
